import { render, staticRenderFns } from "./GlobalProfitSettings.vue?vue&type=template&id=3a554aa2"
import script from "./GlobalProfitSettings.vue?vue&type=script&lang=js"
export * from "./GlobalProfitSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports